import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/useAuthStore";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    // Verificar si el usuario está autenticado al cargar el componente
    if (!isAuthenticated) {
      navigate("/acceso", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Si el usuario está autenticado, renderizar el componente protegido
  if (!isAuthenticated) {
    return null; // Retorna null mientras redirige
  }
  
  return <div>{children}</div>;
};

export default ProtectedRoute;
